import Service from 'react-reservice';

import { EAqxTraderThemeMode, IFontFamily, createTheme } from '@aquariuxfintech/aqx-trader-sdk-config/theme';

import { ibxSansFontFamily } from '../font';
import { EAppThemeMode, EAppThemeScheme, IAppTheme } from '../types';

export interface IAppThemeContext {
  theme: IAppTheme;
  themeScheme: EAppThemeScheme;
  deviceThemeMode: EAppThemeMode;
}

const defaultContext: IAppThemeContext = {
  theme: {
    themeMode: EAppThemeMode.LIGHT,
    themeColors: createTheme({ themeMode: EAqxTraderThemeMode.LIGHT }).themeColors,
    fontFamily: ibxSansFontFamily
  },
  themeScheme: EAppThemeScheme.LIGHT_SCHEME,
  deviceThemeMode: EAppThemeMode.LIGHT
};

class AppThemeService extends Service<IAppThemeContext> {
  constructor() {
    super();
    this.context = defaultContext;
  }

  setThemeScheme = (nextThemeScheme: EAppThemeScheme) => {
    this.context.themeScheme = nextThemeScheme;
  };

  setDeviceThemeMode = (nextDeviceThemeMode: EAppThemeMode) => {
    this.context.deviceThemeMode = nextDeviceThemeMode;
  };

  // When using this, always call createTheme first
  setThemeModeAndColors = (nextTheme: Pick<IAppTheme, 'themeMode' | 'themeColors'>) => {
    this.context.theme = {
      ...this.context.theme,
      ...nextTheme,
      themeColors: {
        ...nextTheme.themeColors
      }
    };
  };

  setPrimaryColor = (nextPrimaryColor: string) => {
    this.context.theme.themeColors.primary = nextPrimaryColor;
  };

  setFontFamily = (nextFontFamily: IFontFamily) => {
    this.context.theme.fontFamily = nextFontFamily;
  };

  setCandlestickColors = (candlestick: { positive: string; negative: string }) => {
    this.context.theme.themeColors.candlestick.positive = candlestick.positive;
    this.context.theme.themeColors.candlestick.negative = candlestick.negative;
  };

  /** Getter */
  getThemeScheme = () => {
    return this.context.themeScheme;
  };

  getThemeColors = () => {
    return this.context.theme.themeColors;
  };
}

export const appThemeService = new AppThemeService();
